<template>
  <div class="temp">
    <!-- header -->
    <div class="header">
      <div class="header_logo"
           @click="logoClick">
        <img src="../src/assets/logo.png"
             alt />
      </div>
      <div class="lan_btn_xs">
        <img src="../src/assets/mobile/Language.png"
             @click="showLanBox"
             style="margin-right:10px;" />
        <!-- 操作指引 -->
        <div class="rules"
             @click="guideDialogVisible = true;">
          <i class="el-icon-tickets"
             style="font-size:24px;"></i>
        </div>
      </div>

      <div class="header_lan"
           v-show="wWidth > 768 || (wWidth < 768 && showLan)">
        <a v-for="item in lang"
           :key="item.code"
           :class="item.code == lan ? 'header_lan_hover':''"
           href="javascript:void(0)"
           @click="setLang(item.code)">{{item.name}}</a>
        <!-- 操作指引 -->
        <div v-if="!$store.state.isMobile"
             class="rules"
             @click="guideDialogVisible = true;">
          <i class="el-icon-tickets"
             style="margin-right:5px;font-size:24px;"></i>
          <span>{{$t('message.guide')}}</span>
        </div>
      </div>
    </div>

    <!-- content -->
    <div class="temp_content">
      <router-view />
    </div>

    <!-- footer -->
    <div class="footer">
      <div class="footer_content">
        <span class="copyRight">© {{new Date().getFullYear()}} - {{$t('message.copyRight')}}</span>
      </div>
    </div>

    <!-- UAT version -->
    <div v-if="['development', 'meta', 'uat'].includes(env)"
         class="uat_version">Version: {{version}}</div>

    <!-- 使用規章彈窗 -->
    <el-dialog :visible.sync="rulesDialogVisible"
               width="665px"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               class="dialog_center_type trems_dialog"
               :title="$t('message.termsTitle')">
      <div class="modal-body">
        <div v-if="serviceType == 'TAXI_ANNUAL'"
             v-html="$t('message.terms_body3')"></div>
        <div v-else-if="serviceType == 'HZMB_RENEW_PERSON' || serviceType == 'HZMB_RENEW_COMPANY'"
             v-html="$t('message.terms_body2')"></div>
        <div v-else-if="serviceType == 'DRV_LIC_INTER'"
             v-html="$t('message.terms_body4')"></div>
        <div v-else-if="serviceType == 'SCHOOL_RENEW'"
             v-html="$t('school.terms_body_school')"></div>
        <div v-else-if="['HEADMASTER_RENEW', 'COACH_RENEW'].includes(serviceType)"
             v-html="$t('school.terms_body_staff')"></div>
        <div v-else-if="serviceType == 'HZMB_MO_RENEW_PERSON' || serviceType == 'HZMB_MO_RENEW_COM'"
             v-html="$t('message.terms_body_hzmb_mo')"></div>
        <div v-else
             v-html="$t('message.terms_body')"></div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <GradientBtn @click="rulesDialogVisible = false;">{{$t('message.close')}}</GradientBtn>
      </span>
    </el-dialog>
    <!-- 操作指引彈窗 -->
    <el-dialog :visible.sync="guideDialogVisible"
               width="665px"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               class="dialog_center_type trems_dialog"
               :title="$t('message.guide')">
      <div>
        <ul class="documents_ul">
          <div v-for="(item,index) in guide"
               :key="index">
            <li v-if="!item.hide"
                :class="`${item.required ? 'my-is-required':'' }`">
              <label style="flex:1;">{{$t(item.label)}}</label>
              <el-button v-if="$store.state.isMobile"
                         class="view_sample"
                         type="warning"
                         :size="$store.state.isMobile ? 'mini' : 'normal'"
                         plain
                         @click="downloadGuide(item)">{{$t('message.download')}}</el-button>
              <a v-else
                 :class="`el-button${$store.state.isMobile ? ' el-button--mini':''} view_sample`"
                 :href="`${localPath}/files/${item[`url${$t('message.lan')}`]}`"
                 target="_blank"
                 :download="item[`filename${$t('message.lan')}`]">{{$t('message.download')}}</a>
            </li>
          </div>
        </ul>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <GradientBtn @click="guideDialogVisible = false;">{{$t('message.close')}}</GradientBtn>
      </span>
    </el-dialog>

    <pdfview v-if="showPdfView"
             :show="showPdfView"
             @close="showPdfView = false;"
             :fileUrl="fileUrl"
             :fileType="fileType"
             :isLocal="true"
             :filename="`filename${$t('message.lan')}`"></pdfview>
  </div>
</template>

<script>
import GradientBtn from "./components/GradientBtn";
import i18n from "../public/lang/index";
import pdfview from "./components/PdfView";
export default {
  components: { GradientBtn, pdfview },
  data () {
    return {
      showLan: false,
      rulesDialogVisible: false,
      guideDialogVisible: false,
      version: "",
      nodeEnv: "",
      guide: [
        {
          label: "message.guide_title4",
          urlTc: "/first_personal.pdf",
          urlPt: "/first_personal_pt.pdf",
          urlEn: "/first_personal_pt.pdf",
          filenameTc: "個人配額提交申請文件_用戶指南.pdf",
          filenamePt: "“Guia para utilizadores” do serviço de entrega dos documentos para pedido de quota particular.pdf",
          filenameEn: "“Guia para utilizadores” do serviço de entrega dos documentos para pedido de quota particular.pdf",
          // hide:true
        },
        {
          label: "message.guide_title5",
          urlTc: "/first_company.pdf",
          urlPt: "/first_company_pt.pdf",
          urlEn: "/first_company_pt.pdf",
          filenameTc: "公司配額提交申請文件_用戶指南.pdf",
          filenamePt: "“Guia para utilizadores” do serviço de entrega dos documentos para pedido de quota comercial.pdf",
          filenameEn: "“Guia para utilizadores” do serviço de entrega dos documentos para pedido de quota comercial.pdf",
          // hide:true
        },
        {
          label: "message.guide_title1",
          urlTc: "/renew_personal.pdf",
          urlPt: "/renew_personal_pt.pdf",
          urlEn: "/renew_personal_pt.pdf",
          filenameTc: "個人配額內地報備續期_用戶指南.pdf",
          filenamePt: "Quotas particulares para a autoridade do Interior da China tomar conhecimento da renovação_v1.0.pdf",
          filenameEn: "Quotas particulares para a autoridade do Interior da China tomar conhecimento da renovação_v1.0.pdf",
        },
        {
          label: "message.guide_title2",
          urlTc: "/renew_company.pdf",
          urlPt: "/renew_company_pt.pdf",
          urlEn: "/renew_company_pt.pdf",
          filenameTc: "公司配額內地報備續期_用戶指南.pdf",
          filenamePt: "Quotas comerciais para a autoridade do Interior da China tomar conhecimento da renovação_v1.0.pdf",
          filenameEn: "Quotas comerciais para a autoridade do Interior da China tomar conhecimento da renovação_v1.0.pdf",
        },
        {
          label: "message.guide_title3",
          urlTc: "/search.pdf",
          urlPt: "/search_pt.pdf",
          urlEn: "/search_pt.pdf",
          filenameTc: "查看辦理進度及補交文件_用戶指南.pdf",
          filenamePt: "Consulta do pedido e documentos por suprir.pdf",
          filenameEn: "Consulta do pedido e documentos por suprir.pdf",
        },
        {
          label: "message.guide_title10",
          urlTc: "/mo_renew_personal.pdf",
          urlPt: "/mo_renew_personal_pt.pdf",
          urlEn: "/mo_renew_personal_pt.pdf",
          filenameTc: "澳門配額續期(個人配額)_用戶指南.pdf",
          filenamePt: "Renovação de quota de Macau (quota para entidade particular).pdf",
          filenameEn: "Renovação de quota de Macau (quota para entidade particular).pdf",
        },
        {
          label: "message.guide_title11",
          urlTc: "/mo_renew_company.pdf",
          urlPt: "/mo_renew_company_pt.pdf",
          urlEn: "/mo_renew_company_pt.pdf",
          filenameTc: "澳門配額續期(公司配額)_用戶指南.pdf",
          filenamePt: "Renovação de quota de Macau (quota para entidade comercial).pdf",
          filenameEn: "Renovação de quota de Macau (quota para entidade comercial).pdf",
        },
        {
          label: "hzmbChange.label.guide_change_person",
          urlTc: "/hzmb_change_person.pdf",
          urlPt: "/hzmb_change_person_pt.pdf",
          urlEn: "/hzmb_change_person_pt.pdf",
          filenameTc: "更換車輛或駕駛員服務（個人配額）_用戶指南.pdf",
          filenamePt: "Atribuição de quota regular para circulação de automóveis de Macau entre Macau e Hong Kong na Ponte HZM – Substituição de veículo ou condutor.pdf",
          filenameEn: "Atribuição de quota regular para circulação de automóveis de Macau entre Macau e Hong Kong na Ponte HZM – Substituição de veículo ou condutor.pdf",
        },
        {
          label: "hzmbChange.label.guide_change_comp",
          urlTc: "/hzmb_change_comp.pdf",
          urlPt: "/hzmb_change_comp_pt.pdf",
          urlEn: "/hzmb_change_comp_pt.pdf",
          filenameTc: "更換車輛或駕駛員服務（公司配額）_用戶指南.pdf",
          filenamePt: "Atribuição de quota regular para circulação de automóveis de Macau entre Macau e Hong Kong na Ponte HZM – Substituição de veículo ou condutor.pdf",
          filenameEn: "Atribuição de quota regular para circulação de automóveis de Macau entre Macau e Hong Kong na Ponte HZM – Substituição de veículo ou condutor.pdf",
        },
        {
          label: "hzmbChange.label.guide_gh_change_comp",
          urlTc: "/hzmb_gh_change_comp.pdf",
          urlPt: "/hzmb_gh_change_comp_pt.pdf",
          urlEn: "/hzmb_gh_change_comp_pt.pdf",
          filenameTc: "跨境客運更換駕駛員服務_用戶指南.pdf",
          filenamePt: "Transporte transfronteiriço de passageiros entre Hong Kong e Macau- Substituição de condutor.pdf",
          filenameEn: "Transporte transfronteiriço de passageiros entre Hong Kong e Macau- Substituição de condutor.pdf",
        },
        {
          label: "message.guide_title6",
          urlTc: "/taxi.pdf",
          urlPt: "/taxi_pt.pdf",
          urlEn: "/taxi_pt.pdf",
          filenameTc: "的士駕駛員證繳付年度費用_用戶指南繁體.pdf",
          filenamePt: "Pagamento da taxa anual do cartão de identificação do condutor de táxi_Guia de utilizador_Chinês tradicional.pdf",
          filenameEn: "Pagamento da taxa anual do cartão de identificação do condutor de táxi_Guia de utilizador_Chinês tradicional.pdf",
        },
        {
          label: "message.guide_title7",
          urlTc: "/coach_renew.pdf",
          urlPt: "/coach_renew_pt.pdf",
          urlEn: "/coach_renew_pt.pdf",
          filenameTc: "駕駛教練員准照續期_用戶指南繁體_ver.20211231.pdf",
          filenamePt: "Renovação da Licença de Instrutor de Condução_Guia de utilizador_Português_ver.20220104.pdf",
          filenameEn: "Renovação da Licença de Instrutor de Condução_Guia de utilizador_Português_ver.20220104.pdf",
        },
        {
          label: "message.guide_title8",
          urlTc: "/headmaster_renew.pdf",
          urlPt: "/headmaster_renew_pt.pdf",
          urlEn: "/headmaster_renew_pt.pdf",
          filenameTc: "駕駛學校校長准照續期_用戶指南繁體_ver.20211231.pdf",
          filenamePt: "Renovação da Licença de Director da Escola de Condução_Guia de utilizador_Português_ver.20220104.pdf",
          filenameEn: "Renovação da Licença de Director da Escola de Condução_Guia de utilizador_Português_ver.20220104.pdf",
        },
        {
          label: "message.guide_title9",
          urlTc: "/school_renew.pdf",
          urlPt: "/school_renew_pt.pdf",
          urlEn: "/school_renew_pt.pdf",
          filenameTc: "駕駛學校執照續期_用戶指南繁體_ver.20211231.pdf",
          filenamePt: "Renovação de Alvará de Escola de Condução_Guia de utilizador_Português_ver.20220104.pdf",
          filenameEn: "Renovação de Alvará de Escola de Condução_Guia de utilizador_Português_ver.20220104.pdf",
        },
        {
          label: "message.guide_title12",
          urlTc: "/hzmb_g_first.pdf",
          urlPt: "/hzmb_g_first.pdf",
          urlEn: "/hzmb_g_first.pdf",
          filenameTc: `${i18n.t('message.guide_title12')}.pdf`,
          filenamePt: `${i18n.t('message.guide_title12')}.pdf`,
          filenameEn: `${i18n.t('message.guide_title12')}.pdf`,
        },
        {
          label: "message.guide_title13",
          urlTc: "/hzmb_g_insurance.pdf",
          urlPt: "/hzmb_g_insurance.pdf",
          urlEn: "/hzmb_g_insurance.pdf",
          filenameTc: `${i18n.t('message.guide_title13')}.pdf`,
          filenamePt: `${i18n.t('message.guide_title13')}.pdf`,
          filenameEn: `${i18n.t('message.guide_title13')}.pdf`,
        },
        {
          label: "message.guide_title14",
          urlTc: "/hzmb_h_first_personal.pdf",
          urlPt: "/hzmb_h_first_personal.pdf",
          urlEn: "/hzmb_h_first_personal.pdf",
          filenameTc: `${i18n.t('message.guide_title14')}.pdf`,
          filenamePt: `${i18n.t('message.guide_title14')}.pdf`,
          filenameEn: `${i18n.t('message.guide_title14')}.pdf`,
        },
        {
          label: "message.guide_title15",
          urlTc: "/hzmb_h_first_company.pdf",
          urlPt: "/hzmb_h_first_company.pdf",
          urlEn: "/hzmb_h_first_company.pdf",
          filenameTc: `${i18n.t('message.guide_title15')}.pdf`,
          filenamePt: `${i18n.t('message.guide_title15')}.pdf`,
          filenameEn: `${i18n.t('message.guide_title15')}.pdf`,
        },
        {
          label: "message.guide_title16",
          urlTc: "/hzmb_h_booking.pdf",
          urlPt: "/hzmb_h_booking.pdf",
          urlEn: "/hzmb_h_booking.pdf",
          filenameTc: `${i18n.t('message.guide_title16')}.pdf`,
          filenamePt: `${i18n.t('message.guide_title16')}.pdf`,
          filenameEn: `${i18n.t('message.guide_title16')}.pdf`,
        },
        {
          label: "message.epay_ICRenewal_guide",
          urlTc: "/epay_ICRenewal_cn.pdf",
          urlPt: "/epay_ICRenewal_pt.pdf",
          urlEn: "/epay_ICRenewal_pt.pdf",
          filenameTc: `${i18n.t('message.epay_ICRenewal_guide')}.pdf`,
          filenamePt: `${i18n.t('message.epay_ICRenewal_guide')}.pdf`,
          filenameEn: `${i18n.t('message.epay_ICRenewal_guide')}.pdf`,
        },
        {
          label: "message.epay_Cert_004",
          urlTc: "/epay_Cert_004_cn.pdf",
          urlPt: "/epay_Cert_004_pt.pdf",
          urlEn: "/epay_Cert_004_pt.pdf",
          filenameTc: `${i18n.t('message.epay_Cert_004')}.pdf`,
          filenamePt: `${i18n.t('message.epay_Cert_004')}.pdf`,
          filenameEn: `${i18n.t('message.epay_Cert_004')}.pdf`,
        },
        {
          label: "message.epay_Cert_005",
          urlTc: "/epay_Cert_005_cn.pdf",
          urlPt: "/epay_Cert_005_pt.pdf",
          urlEn: "/epay_Cert_005_pt.pdf",
          filenameTc: `${i18n.t('message.epay_Cert_005')}.pdf`,
          filenamePt: `${i18n.t('message.epay_Cert_005')}.pdf`,
          filenameEn: `${i18n.t('message.epay_Cert_005')}.pdf`,
        },
        {
          label: "message.DSAT0051",
          urlTc: "/DSAT0051.pdf",
          urlPt: "/DSAT0051.pdf",
          urlEn: "/DSAT0051.pdf",
          filenameTc: `${i18n.t('message.DSAT0051')}.pdf`,
          filenamePt: `${i18n.t('message.DSAT0051')}.pdf`,
          filenameEn: `${i18n.t('message.DSAT0051')}.pdf`,
        },
        {
          label: "message.DSAT0046",
          urlTc: "/DSAT0046.pdf",
          urlPt: "/DSAT0046.pdf",
          urlEn: "/DSAT0046.pdf",
          filenameTc: `${i18n.t('message.DSAT0046')}.pdf`,
          filenamePt: `${i18n.t('message.DSAT0046')}.pdf`,
          filenameEn: `${i18n.t('message.DSAT0046')}.pdf`,
        },
      ],
      showPdfView: false,
      fileUrl: "",
      fileType: "pdf",
      guideLoading: false,
      filename: "",
      selection: {},
      localPath: "",
      env: ''
    };
  },
  watch: {
    "$route.path" (val) {
      const previewMessage = localStorage.getItem("previewMessage") || null;
      if (previewMessage && val != "/success") {
        localStorage.setItem("previewMessage", "");
      }
      // 的士繳費只顯示中文繁體
      // if(val == '/'){
      //   this.lang = [
      //     { code: "ZH_TW", name: "中文繁體" },
      //     { code: "PT", name: "Português" },
      //   ];
      //   this.$store.commit('changeServiceType',null);
      // }else if(val == '/entryTaxi'){
      //   this.lang = [
      //     { code: "ZH_TW", name: "中文繁體" },
      //   ];
      // }
    },
    lang(val) {
      // 如果沒有相應的語言，默認切換回繁中
      if(!val.find(e => e.code === this.lan)) {
        this.setLang('ZH_TW');
      }
    }
  },
  computed: {
    wWidth () {
      return this.$store.state.wWidth;
    },
    serviceType () {
      return this.$store.state.serviceType;
    },
    lang() {
      let lans = [
        { code: "ZH_TW", name: "中文繁體" },
        { code: "PT", name: "Português" },
        // { code: "EN", name: "English" }
      ];
      const serviceType = this.$route.params.serviceType || this.$route.meta.serviceType;
      if (this.$route.meta.showEn || ['HZMB_G_FIRST', 'HZMB_G_INSURANCE', 'HZMB_G_CANCEL'].includes(serviceType)) {
        lans.push({ code: "EN", name: "English" })
      }
      return lans;
    },
    lan () {
      return this.$i18n.locale;
    }
  },
  methods: {
    setLang (code) {
      // if (code == "PT") {
      //   alert("Esta página no disponível em Português.");
      // } else if (code == "EN") {
      //   alert("This page is not available in English.");
      // } else {
      localStorage.setItem("lan", code);
      // 保留url參數
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          lang: code,
        }
      });

      location.reload();
      // }
    },
    showLanBox () {
      this.showLan = !this.showLan;
    },
    logoClick () {
      localStorage.setItem("entryType", "application");
      if (!this.$store.state.isMobile) {
        this.$router.push("/");
      }
    },
    downloadGuide (val) {
      this.selection = val;
      const url = `${this.localPath}/files${val[`url${this.$t('message.lan')}`]}`;
      if (this.$store.state.isMobile) {
        this.fileUrl = url;
        this.filename = val[`filename${this.$t('message.lan')}`];
        this.showPdfView = true;
      } else {
        window.open(url);
        window.location.href = url + "?source=edoc";
      }
    },
  },
  created () {
    this.version = process.env.VUE_APP_VERSION;
    this.nodeEnv = process.env.VUE_APP_ENV;
    this.localPath = process.env.VUE_APP_BASE_LOCAL_PATH;

    if (this.$route.path == "/entryBus") {
      localStorage.setItem("childTempTitle", "two");
    } else if (this.$route.path == "/entry") {
      localStorage.setItem("childTempTitle", "one");
    }

    this.env = process.env.VUE_APP_ENV;
  },
};
</script>

<style lang="scss" scoped>
.header {
  background: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-left: 12px;
  padding-right: 12px;
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
}
.header_logo {
  width: 150px;
  cursor: pointer;
}
.header_logo img {
  width: 100%;
  display: block;
}
.header_lan {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.header_lan a {
  display: block;
  padding: 21.5px 24px;
  font-size: 14px;
  color: #3e4143;
  -webkit-transition: all 0.1s ease-in 0.1s;
  transition: all 0.1s ease-in 0.1s;
  border-bottom: 8px solid transparent;
  font-weight: bold;
  line-height: 20px;
}
.header_lan a:hover,
.header_lan_hover {
  background: #f6f6f6;
  border-bottom: 8px solid #f7b135 !important;
}

.rules {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 9px 10.5px;
}
.rules img {
  width: 18px;
  margin-right: 8px;
}
.rules span {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
}
.rules:hover {
  // color: #38959D;
}
.temp_content {
  min-height: 500px;
  position: relative;
}

.footer {
  background: #174866;
  color: #fff;
  font-size: 14px;
  text-align: center;
  padding: 7px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  margin: auto;
}
.footer_content {
  max-width: 1260px;
  width: 100%;
  padding-left: 12px;
  padding-right: 12px;
}
.footer span {
  padding: 10px;
  line-height: 30px;
}

// 表单样式
/deep/.el-form {
  .el-form-item__label {
    font-size: 18px;
    color: #323232;
    text-align: left;
  }
  .el-input__inner, .el-textarea__inner {
    // border-color: #a9b9cc;
    height: 48px;
    line-height: 40px;
    font-size: 16px;
  }
  .el-select {
    width: 100%;
  }
  .el-input.is-active .el-input__inner,
  .el-input__inner:focus {
    // border: 1px solid #5ba7ad;
  }

  .el-input.is-disabled .el-input__inner,
  .el-textarea.is-disabled .el-textarea__inner {
    color: #777;
    background: #f1f2f7;
  }
}

// 通用按钮样式
/deep/.pub_btn {
  .el-button {
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid #5ba7ad;
    color: #38959d;
    font-size: 14px;
    line-height: 20px;
    padding: 7px 17px;
  }
  .el-button:focus,
  .el-button:hover {
    background-color: #ecf5ff;
  }
  .el-button.is-disabled.is-plain,
  .el-button.is-disabled.is-plain:focus,
  .el-button.is-disabled.is-plain:hover {
    background-color: #fff;
    border-color: #ebeef5;
    color: #c0c4cc;
  }
  // 查看樣本按鈕樣式
  /deep/.view_sample {
    background: #fff !important;
    border-color: #f7b135 !important;
    color: #f7b135 !important;
    min-width: 98px;
  }
  /deep/.view_sample:hover {
    background: #f7b135 !important;
    border-color: #f7b135 !important;
    color: #fff !important;
  }
}

/deep/.el-form-item.is-error .el-input__inner,
.el-form-item.is-error .el-input__inner:focus,
.el-form-item.is-error .el-textarea__inner,
.el-form-item.is-error .el-textarea__inner:focus,
.el-message-box__input input.invalid,
.el-message-box__input input.invalid:focus {
  border-color: #f40101;
  box-shadow: 0px 0px 2px 2px rgba(198, 9, 9, 0.03);
}
/deep/.el-form-item__error {
  color: #f40101;
  font-size: 14px;
}

/deep/.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/.is-required {
  .el-form-item__label:after {
    content: '*';
    color: #f56c6c;
    margin-left: 4px;
  }
}

/deep/.el-input {
  .el-input-group--append .el-input__inner,
  .el-input-group__prepend {
    min-width: 35px;
    text-align: center;
  }
}

.lan_btn_xs {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
}
.lan_btn_xs img {
  width: 24px;
  height: auto;
}
/deep/.dialog_center_type {
  .el-dialog {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 9px 2px rgba(0, 0, 0, 0.25);
    border-radius: 17px;
    max-width: 90%;
  }
  .el-dialog__header {
    text-align: center;
    font-weight: 600;
    color: rgba(62, 65, 67, 1);
    line-height: 33px;
    padding: 45px 20px 10px;
    .el-dialog__title {
    }
    .el-dialog__close {
      background: rgba(243, 243, 243, 1);
      border-radius: 50px;
      font-weight: bold;
      -webkit-transition: all 0.1s ease-in 0.1s;
      transition: all 0.1s ease-in 0.1s;
    }
    .el-dialog__close:hover {
      background: #5ba7ad;
      color: #fff;
    }
    .el-dialog__headerbtn {
      top: 16px;
    }
  }
  .el-dialog__body {
    font-size: 14px;
    line-height: 20px;
    padding: 20px;
  }
  .el-dialog__footer {
    text-align: center;
  }
}

/deep/.dialog_center_type {
  .el-dialog {
    overflow: hidden;
    .el-dialog__footer {
      margin: 24px 0;
    }
  }
}
/deep/.el-dialog:not(.is-fullscreen) {
  max-width: 90%;
}

/deep/input::-webkit-input-placeholder {
  color: #dcdcdc !important;
}
/deep/input::-moz-input-placeholder {
  color: #dcdcdc !important;
}
/deep/input::-ms-input-placeholder {
  color: #dcdcdc !important;
}

/deep/.my-is-required label:after {
  content: '*';
  color: #f56c6c;
  margin-left: 4px;
}
// 顯示彈窗時會出現padding，未清楚原因
// /deep/.el-popup-parent--hidden {
//   padding: 0 !important;
// }
// 查看樣本按鈕樣式
/deep/.view_sample {
  background: #fff !important;
  border-color: #f7b135 !important;
  color: #f7b135 !important;
  min-width: 98px;
  word-break: keep-all;
}
/deep/.view_sample:hover {
  background: #f7b135 !important;
  border-color: #f7b135 !important;
  color: #fff !important;
}
.watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 16%;
  max-width: 320px;
}
.watermark img {
  width: 100%;
}
.uat_version {
  background: #ad3d40;
  color: #fff;
  text-align: center;
  padding: 10px;
  font-size: 16px;
}
@media screen and (max-width: 767px) {
  .header_logo {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 90px;
  }
  .header_lan {
    flex-direction: column;
    position: absolute;
    right: 0;
    top: 50px;
    align-items: initial;
    text-align: center;
    background: #fff;
    box-shadow: 0px 2px 5px -1px rgba(55, 55, 55, 0.23);
    border: 1px solid #f1f1f1;
    z-index: 100;
  }
  .header_lan a:hover,
  .header_lan_hover {
    background: #f5fbff;
    color: #2697f7 !important;
  }
  .header_lan a {
    border-bottom: 1px solid #eaeaea;
    font-size: 14px;
    padding: 12px 15px;
  }

  /deep/.el-form {
    .el-form-item__label {
      font-size: 16px;
    }
    .el-input__inner {
      height: 40px;
      line-height: 36px;
      font-size: 16px;
    }
  }
  /deep/.dialog_center_type {
    .el-dialog__title {
      font-size: 18px;
    }
    .el-dialog__close {
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
    }
    .el-button + .el-button {
      margin-left: 0;
      margin-top: 20px;
    }
  }
  /deep/.view_sample {
    min-width: 80px;
  }
  /deep/.el-select-dropdown {
    position: absolute !important;
    top: 38px !important;
    left: 0 !important;
  }
}
/deep/.el-message__content {
  white-space: pre-wrap;
}
/deep/.el-button {
  span {
    white-space: normal;
  }
}
/deep/.el-row {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
}
/deep/.captcha_row {
  .el-input {
    flex: 1;
  }
}
@media screen and (max-width: 767px) {
}
@media screen and (min-width: 768px) {
  .lan_btn_xs {
    display: none;
  }

  .rules {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 9px 10.5px;
    border-radius: 15px;
    background: #fff;
    color: #333;
    margin-left: 10px;
    margin-bottom: 8px;
  }
  .rules:hover {
    background: #139c8f;
    color: #fff;
  }

  /deep/.dialog_center_type {
    .el-dialog__title {
      font-size: 24px;
    }
    .el-dialog__close {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 20px;
    }
    .el-button + .el-button {
      margin-left: 6%;
    }
  }
}
</style>